import { CanDeactivateFn } from '@angular/router';

export interface ComponentWithUnsavedChanges {
  canDeactivate(): boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<ComponentWithUnsavedChanges> = (component) =>
  component.canDeactivate();
